import React, {useCallback} from 'react';
import {RadioField} from 'forms/src';
import {QuizQuestionConfig} from '../../types';
interface Props {
    question: QuizQuestionConfig;
    invalidQuestionIndexes: number[];
    questionIndex: number;
    value: number;
    onValueChange: (questionIndex, choiceIndex) => void;
}

const QuizQuestion = ({question, invalidQuestionIndexes, questionIndex, onValueChange, value}: Props) => {
    const handleRadioInputChange = useCallback((newValue) => {
        onValueChange(questionIndex, newValue);
    }, [onValueChange]);
    const options = question.choices.map(
        (choice, choiceIndex) => ({value: choiceIndex, label: choice.choiceText})
    );
    return <div key={questionIndex} className={invalidQuestionIndexes.includes(questionIndex) ? 'invalid' : ''}>
        <div>
            {question.questionText}
        </div>
        <RadioField
            options={options}
            value={value}
            onValueChange={handleRadioInputChange}/>
    </div>;
};

export default QuizQuestion;
